import * as React from 'react';
import {
    Route,
    Switch,
    withRouter,
} from 'react-router-dom';
import { compose } from 'recompose';
import { Suspense } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import NotFound from 'src/components/NotFound';
import MagicInviteLanding from 'src/features/Auth/SignUp/MagicLinkInviteLanding';
import MagicLinkLanding from 'src/features/Auth/SignUp/MagicLinkLanding';


const MagicLanding = (props: any) => {
    const {
        match: { path },
    } = props;
    return (
        <Suspense fallback={<SuspenseLoader />}>
            <Switch>
                <Route exact path={`${path}`} component={MagicLinkLanding} />
                <Route path={`${path}/invite`} component={MagicInviteLanding} />
                <Route component={NotFound} />
            </Switch>
        </Suspense>
    );
}

export default compose(withRouter)(MagicLanding);